import React from 'react'
import Carousel from 'react-multi-carousel';
import "react-multi-carousel/lib/styles.css";

export default function Karuselli(props) {
    const responsive = {
        desktop: {
          breakpoint: { max: 3000, min: 992 },
          items: 1,
          slidesToSlide: 1 // optional, default to 1.
        },
        tablet: {
          breakpoint: { max: 991, min: 768 },
          items: 1,
          slidesToSlide: 1 // optional, default to 1.
        },
        mobile: {
          breakpoint: { max: 767, min: 0 },
          items: 1,
          slidesToSlide: 1 // optional, default to 1.
        }
    };
    return (
        <Carousel
        draggable={false}
        showDots={true}
        responsive={responsive}
        infinite={true}
        keyBoardControl={true}
        customTransition="all .5"
        transitionDuration={500}
        containerClass="carousel-container"
        removeArrowOnDeviceType={["tablet", "mobile"]}
        dotListClass="custom-dot-list-style"
        itemClass="carousel-item-padding-10-px"
        >

        {/* Ensimmäinen laatikko */}
        <div className="text-center matkailuauto_laatikko text-white">
            <h2 className="py-1 py-lg-0">Vuokrataan matkailuauto</h2>
            <a href="Matkailuauto" ><img className="autokuva img-fluid rounded" alt="matkailuauto" src={require("../img/matkailuauto(2).webp").default}></img></a>
            <h3 className="py-1">SUNLIGHT T68</h3>
            <p className="d-none d-md-block"><a href="Matkailuauto" className="mb-2 text-white fw-bold lisatiedotNappi"><i className="far fa-arrow-alt-circle-right me-1"></i>Katso lisätiedot</a></p>
            <p className="px-4 pt-1 pb-3 d-md-none">Vuosimalli 2022. Polttoaine diesel. Rekisteröity (5) viidelle henkilölle.</p>

            <section className="row m-auto">
                <div className="col-5">
                <p><b>KESÄ- ELOKUU</b> <br />
                1200€/vko sis. 2100km </p>
                </div>

                <div className="col-7">
                <p><b>SYYS- ja KEVÄTVIIKOT</b> <br />
                990€/vko sis. 2100km</p>
                </div>
                <br />
                <p className="py-2 d-md-none"><a href="Matkailuauto" className="mb-2 text-white fw-bold lisatiedotNappi"><i className="far fa-arrow-alt-circle-right me-1"></i>Katso lisätiedot</a></p>
                <p>Ei talvivuokrausta</p>
                <p className="pb-lg-2">Varaukset Marko Kantola: 044 5555 253</p>
            </section>
                

                
        </div>

        <div className="karuselli_laatikko">
            <h2 className="laatikon2_otsikko pt-md-4 pt-lg-1">Hinnasto</h2>
            <section className=" px-1 row text-center hinnasto2">

                <div className="col-md-6 ">
                    <div className="hinnasto_laatikko m-0">
                        <h3 className="pt-1">Myyntipöytä</h3>
                        <p className="pt-2 mb-2"><u>Kaksi tasoa</u></p>
                        <p className="mb-2">Mitat</p>
                        <p className="mb-2">110 x 80cm</p>
                        <p className="mb-2"><b>29€ / Viikko</b></p>
                        <a href="https://www.kirpparikalle.net/sovellus" target="_blank" rel="noreferrer">
                        <button className="btn btn-primary varaus_painike m-1">VARAA PÖYTÄ</button>
                        </a>
                    </div>
                </div>

                <div className="col-md-6">
                    <div className="hinnasto_laatikko">
                        <h3  className="pt-1">Myyntihyllykkö</h3>
                        <p className="pt-2 mb-2"><u>Kolme tasoa</u></p>
                        <p className="mb-2">Mitat 130 x 80 cm</p>
                        <p className="mb-2"><b>13€ / Viikko</b></p>
                        <p className="mb-2"><b>Rekillä 23€ / Viikko</b></p>
                        <a href="https://www.kirpparikalle.net/sovellus" target="_blank" rel="noreferrer">
                        <button className="btn btn-primary varaus_painike m-1">VARAA PÖYTÄ</button>
                        </a>
                    </div>
                </div>


                {/* <div className="col-md-6 ">
                    <div className="hinnasto_laatikko m-0">
                        <h3 className="pt-1">Muokattava myyntihylly</h3>
                        <p className="pt-2 mb-2"><u>Kolme hyllylevyä</u></p>
                        <p className="mb-2">2 henkaritankoa ja henkarit</p>
                        <p className="mb-2">Yksi korihylly</p>
                        <p className="mb-2"><b>17€ / Viikko</b></p>
                        <a href="https://www.kirpparikalle.net/sovellus" target="_blank" rel="noreferrer">
                        <button className="btn btn-primary varaus_painike m-1">VARAA PÖYTÄ</button>
                        </a>
                    </div>
                </div> */}

                <div className="col-md-12 ">
                    <div className="hinnasto_laatikko">
                        <h3  className="pt-1">Muut</h3>
                        <p className="pt-2 mb-2">Siistipalvelu - 2€/krt 10€/viikko</p>
                        <p className="mb-2">Hintalappuarkki - 0,50€</p>
                        <p className="mb-2">Tarrahäly - 0,25€</p>
                        <p className="mb-2">Kuljetuspalvelu - alk.20€</p>
                        <a href="https://www.kirpparikalle.net/sovellus" target="_blank" rel="noreferrer">
                        <button className="btn btn-primary varaus_painike m-1">VARAA PÖYTÄ</button>
                        </a>
                    </div>
                </div>
                {/* <div className="col-12 pt-md-2 pt-lg-0 karuselli_laatikko">
                    <div className="hinnasto_laatikko_iso mt-2">
                        <h3 className="pt-2 pb-1">Muut</h3>
                        <p className="pt-2">Siistipalvelu - 2€/krt 10€/viikko</p>
                        <p>Hintalappuarkki - 0,50€</p>
                        <p>Tarrahäly - 0,25€</p>
                        <p className="mb-2 pb-2">Kuljetuspalvelu - alk.15€</p>
                        </div>
                    </div> */}
            </section>
        </div>
        <div className="p-xl-4 p-lg-2 p-md-1 karuselli_laatikko">
            <div className="myynti_varaaminen text-center">
                <h3 className="laatikon2_otsikko">Myyntipaikat ja varaaminen</h3>
                <p className="pt-4">Voit valita myyntipaikan kahdesta vaihtoehdosta. <br />
                Tarjolla on siistejä kaksitasoisia myyntipöytiä tai pienempiä myyntihyllyköitä. <br />
                Molemmissa on henkaritanko. <br />
                Henkarit löytyy myyntipaikasta. </p>
                <p className="pb-2 px-2"><span className="fas fa-bullseye"></span>
                &nbsp; Myyntipöydän koko on 110 x 80cm ja se sisältää kivan ylähyllyn.
                </p>
                <p className="pb-2 px-2"><span className="fas fa-bullseye"></span>
                &nbsp; Myyntihyllykön koko on 130 x 80 cm , hyllykössä 3 tilavaa hyllyä.
                </p>
                <p>Myyntipaikan voi varata KirppariKallen kautta, 
                    jolloin voit seurata myyntiä netin kautta
                </p>

                <a href="https://www.kirpparikalle.net/sovellus" target="_blank" rel="noreferrer">
                            <button className="btn btn-primary varaus_painike m-1">VARAA PÖYTÄ</button>
                </a>

                <p className="pt-2">Tai varaa paikka puhelimitse</p>
                <p>Puhelin: <span className="puh_nro"> 0405957281 <span className="fas fa-phone"></span></span></p>
            </div>
        </div>
        <div className="p-xl-4 p-lg-2 p-md-1 karuselli_laatikko">
            <div className="provisiomyynti text-center">
                <h3>PROVISIOMYYNTI</h3>
                <p>Voit tuoda myyntiin myös huonekaluja. Esim. 
                Retroa, antiikki- ja talonpoikaishuonekaluja. 
                Huonekalut tulee olla siistejä ja ehjiä. Kysy henkilökunnalta, mahtuuko huonekaluja myyntiin. 
                Huonekalujen myyntiaika on 3 viikkoa.</p>

                <div className="provisiomyynti2 row">
                    <table>
                        <tbody>
                        <tr>
                            <th>Paikkamaksu pienet huonekalut</th>
                            <th> 5€ </th>
                        </tr>

                        <tr>
                            <th>Paikkamaksu isot huonekalut</th>
                            <th> 10€ </th>
                        </tr>
                        <tr>
                            <th>Myyntiprovisio</th>
                            <th> 25% </th>
                        </tr>
                        <tr>
                            <th>Pöytämyyjiltä</th>
                            <th> 20% </th>
                        </tr>
                        </tbody>
                    </table>
                </div>

                <p className="iso_puh_nro">Puhelin: <span className="puh_nro"> 0405957281 <span className="fas fa-phone"></span></span></p>
                    <p className="alateksti">Emme ota myyntiin sänkyjä, joustinpatjoja tai isoja kirjahyllyjä!</p>
            </div>
        </div>
        </Carousel>
    )
}
